import React from 'react'
import { connect } from 'react-redux'
import { IconButton } from '@material-ui/core'
import { KeyboardBackspace } from '@material-ui/icons'
import { TABLET_BREAKPOINT } from 'helpers/responsive'
import { ReactComponent as InfoIcon } from 'assets/img/Info-icon.svg'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'

function JobsNav({
  activeSite,
  onReturnBack,
  breadcrumbs,
  handleOpenInfoModal,
}) {
  const strBreadCrumbs = breadcrumbs.map(item => item.name).join(' ')

  return (
    <div className="jobs-nav">
      <IconButton size="small" className="btn-back" onClick={onReturnBack}>
        <KeyboardBackspace />
      </IconButton>
      {ifWindowWidthLessThan(TABLET_BREAKPOINT) && (
        <IconButton onClick={handleOpenInfoModal} className="info-icon">
          <InfoIcon />
        </IconButton>
      )}
      {!!activeSite && (
        <span className="nav-crumb">
          {`${activeSite.get('name')} / ${strBreadCrumbs}`}
        </span>
      )}
    </div>
  )
}

JobsNav.defaultProps = {
  breadcrumbs: [],
  onReturnBack: () => {},
}

export default connect(state => ({
  activeSite: state.getIn(['myJobs', 'activeSite']),
}))(JobsNav)
